import DrawerLayout from "lib/common/drawer/DrawerLayout";
import { asMarionetteView } from "lib/common/hoc/BackboneReact/asMarionetteView";
import Default from "./Default";
import { BackboneSearchModule } from "./lib/search/SearchModule";
import DataEntryFormModule from "./lib/dataentryform/DataEntryFormModule";
import CallbackContainer from "data/util/CallbackContainer";
import NavigatorStore from "data/NavigatorStore";
import FormStore from "data/meta/FormStore";
import BrowserStore from "data/BrowserStore";
import StereotypesStore from "data/StereotypesStore";
import Dispatcher from "Dispatcher";
import SearchFormActions from "data/SearchFormActions";

const MarionetteSearchModule = asMarionetteView(BackboneSearchModule);

class DataEntryModule extends DrawerLayout {
    constructor(...args) {
        super(...args);
        this.onRender = this.onRender.bind(this);
        this.searchOnRender = !!args[0].searchOnRender;
        this.useDefaultSearch = !!args[0].useDefaultSearch;
    }

    onDomRefresh() {
        this.model.set("boundingElement", this.$el[0].parentNode);
    }

    onRender() {
        const {
            model, // this is appModel everywhere else
        } = this;
        const fluxContext = model.get("fluxContext");

        // select the default stereotype, if one isn't already selected
        Dispatcher.contextDispatch(fluxContext, {
            type: SearchFormActions.INITIALIZE_CONTEXT,
            key: StereotypesStore.getDefaultKey(),
            availableKeys: StereotypesStore.getDataEntryStereotypes()
                .map(s => s.key),
            useDefaultSearch: this.useDefaultSearch,
            initiateSearch: this.searchOnRender,
        });
        this.searchModule = new MarionetteSearchModule({
            appModel: this.model,
            showCreate: true,
            useDefaultSearch: this.useDefaultSearch,
        });

        this.drawer.show(this.searchModule);
        const resizeToken = CallbackContainer.createFunctional(
            () => this.searchModule.render(),
            () => [
                BrowserStore,
            ],
            () =>
                BrowserStore.getSize(),
        );
        this.on("before:close", () => resizeToken.close());

        const formToken = CallbackContainer.createFunctional(
            props => {
                //create and display the data entry form
                if (props && props.hasForm) {
                    if (this.dev == null) {
                        this.dev = new DataEntryFormModule({
                            fluxContext: this.model.get("fluxContext"),
                            isModal: this.model.get("isModal"),
                        });
                    }
                    if (this.dev !== this.content.currentView) {
                        // this replaces the DOM for the entire DE layer
                        this.content.show(this.dev);
                    }
                    if (props.doFormTransition) {
                        this.onDrawerEnable();
                        this.onDrawerClose();
                    }
                    this.dev.showForm();
                } else {
                    if (props.doFormTransition) {
                        const mv = new (asMarionetteView(Default))({
                            fluxContext,
                        });
                        this.onDrawerOpen();
                        this.content.show(mv);
                    }
                }
            },
            () => [
                NavigatorStore,
                FormStore,
            ],
            prev => {
                const next = {
                    ...NavigatorStore.getState(fluxContext),
                };
                // This is sorta wonky, because Flux/React are about rendering
                // while Marionette is about transitioning. C'est la vie.
                next.hasForm = next && next.magic != null;
                next.doFormTransition = prev == null
                    || next.hasForm !== prev.hasForm
                    || next.magic !== prev.magic;
                // End wonky.
                if (next.record) {
                    next.formLO = FormStore.getFormLO(next.record.key);
                }
                if (prev == null) return next;
                if (prev.magic !== next.magic) return next;
                if (prev.record !== next.record) return next;
                if (prev.formLO !== next.formLO) return next;
                return prev;
            }
        );
        formToken.force();
        this.on("before:close", () => formToken.close());
    }
}

DataEntryModule.prototype.className = "de-layout";

export default DataEntryModule;



// WEBPACK FOOTER //
// ./app/lib/dataentry/DataEntryModule.js